var React = require('react');

function IcAwsRdsDbInstance (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M20,0C12.815,0,5.179,2.035,5.179,5.808v28.384C5.179,37.965,12.815,40,20,40s14.821-2.035,14.821-5.808V5.808\n\tC34.821,2.035,27.185,0,20,0z M20,1.701c7.47,0,12.279,2.019,13.011,3.678C32.28,7.037,27.471,9.056,20,9.056\n\tS7.72,7.037,6.988,5.378C7.72,3.72,12.529,1.701,20,1.701z M33.121,34.192c0,1.715-4.992,4.107-13.12,4.107\n\tc-8.129,0-13.121-2.392-13.121-4.107V7.756c2.65,1.962,7.996,3,13.121,3c5.126,0,10.472-1.039,13.12-3.003V34.192z M12.218,18.216\n\tv15.321h2.918V22.925l3.383,6.877h2.963l3.382-6.877v10.613h2.918V18.216h-3.559l-4.201,8.711l-4.178-8.711H12.218z"}));
}

IcAwsRdsDbInstance.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsRdsDbInstance;

IcAwsRdsDbInstance.default = IcAwsRdsDbInstance;
